module.exports = __webpack_public_path__ + "img/img_018@2x.b06cf82c.png";